import React, { useState } from 'react';
import { useHistory, Link } from 'react-router-dom';
import { signupUser } from '../../auth/authService'; // Create this function
import { FaUser, FaLock, FaEye, FaEyeSlash, FaSpinner, FaPhone, } from "react-icons/fa";
import { FaPhoneSlash } from "react-icons/fa";
import { MdPhoneInTalk } from "react-icons/md";

const SignupPage = () => {
  const [username, setUsername] = useState('');
  const [phone, setPhone] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const history = useHistory();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    try {
      await signupUser({ username, phone, password });
      history.push('/'); // After signup, redirect to login
    } catch (err) {
      setError(err.message || 'Signup failed');
    }
  };

  const [isHovered, setIsHovered] = useState(false);

  const baseStyles = {
    width: "100%",
    padding: "10px",
    marginTop: "15px",
    borderRadius: "8px",
    border: "1px solid #fff",
    background: loading
      ? "#fff"
      : isHovered
        ? "#e9b571ff" // light green on hover
        : "transparent",
    color: loading
      ? "#000"
      : isHovered
        ? "#000" // text turns black on hover
        : "#fff",
    fontWeight: "bold",
    cursor: loading ? "not-allowed" : "pointer",
    transition: "all 0.3s ease",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    gap: "8px",
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-r from-purple-500 to-pink-600">
      <div
        style={{
          width: "100%",
          maxWidth: "400px",
          padding: "30px",
          borderRadius: "16px",
          background: "#1e1e1e",
          boxShadow: "0 0 20px rgba(0,0,0,0.3)",
          textAlign: "center",
          transform: "scale(1)",
          animation: "fadeIn 1s ease",
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: "20px", // Space between image and text
          }}
        >

          <h6
            style={{
              fontWeight: "600",
              fontFamily: "monospace",
              color: "#fff",
              textTransform: "uppercase",
            }}
          >
            Sign Up to Astro Vision
          </h6>
        </div>

        {error && <div className="text-red-500 mb-4 text-sm">{error}</div>}

        <form onSubmit={handleSubmit} className="space-y-4">
          <div style={{ position: "relative", marginBottom: "15px" }}>
            <FaUser
              style={{
                position: "absolute",
                top: "50%",
                left: "10px",
                transform: "translateY(-50%)",
                color: "#ccc",
              }}
            />
            <input
              type="text"
              placeholder="User Name"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              style={{
                width: "100%",
                padding: "10px 10px 10px 40px",
                borderRadius: "8px",
                border: "1px solid #4c6793",
                background: "#2E2E2E",
                color: "#fff",
                outline: "none",
                transition: "border 0.3s ease",
              }}
            />
          </div>

          <div style={{ position: "relative", marginBottom: "15px" }}>
            <MdPhoneInTalk
              style={{
                position: "absolute",
                top: "50%",
                left: "10px",
                transform: "translateY(-50%)",
                color: "#ccc",
              }}
            />
            <input
              type="text"
              placeholder="Phone"
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
              style={{
                width: "100%",
                padding: "10px 10px 10px 40px",
                borderRadius: "8px",
                border: "1px solid #4c6793",
                background: "#2E2E2E",
                color: "#fff",
                outline: "none",
                transition: "border 0.3s ease",
              }}
            />
          </div>

          <div style={{ position: "relative", marginBottom: "15px" }}>
            <FaLock
              style={{
                position: "absolute",
                top: "50%",
                left: "10px",
                transform: "translateY(-50%)",
                color: "#ccc",
              }}
            />
            <input
              type={showPassword ? "text" : "password"}
              placeholder="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              style={{
                width: "100%",
                padding: "10px 10px 10px 40px",
                borderRadius: "8px",
                border: "1px solid #4c6793",
                background: "#2E2E2E",
                color: "#fff",
                outline: "none",
                transition: "border 0.3s ease",
              }}
            />
            <div
              onClick={() => setShowPassword((prev) => !prev)}
              style={{
                position: "absolute",
                top: "50%",
                right: "10px",
                transform: "translateY(-50%)",
                color: "#ccc",
                cursor: "pointer",
              }}
            >
              {showPassword ? <FaEyeSlash /> : <FaEye />}
            </div>
          </div>

          {/* <button
            type="submit"
            className="w-full bg-purple-600 text-white py-2 rounded hover:bg-purple-700"
          >
            Create Account
          </button> */}
          <button
            type="submit"
            disabled={loading}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
            style={baseStyles}
          >
            {loading && (
              <FaSpinner style={{ animation: "spin 1s linear infinite" }} />
            )}
            {loading ? "  Creating Account in..." : "  Create Account"}
          </button>
        </form>
        <p className="text-gray-400 mt-4">
          Already have an account?{' '}
          <Link to="/" className="text-indigo-600 hover:underline font-medium">
            Login
          </Link>
        </p>
      </div >
    </div>
  );
};

export default SignupPage;
